import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL, APP_BASE_URL } from "../../config";
import { QRCodeCanvas } from "qrcode.react";

// Tabs Components
import BasicInfo from "./tabs/BasicInfo";
import LocationInfo from "./tabs/LocationInfo";
import SupplierInfo from "./tabs/SupplierInfo";
import PriceInfo from "./tabs/PriceInfo";
import LicenseInfo from "./tabs/LicenseInfo";
import StatusInfo from "./tabs/StatusInfo";
import WorkOrders from "./tabs/WorkOrders";
import Documents from "./tabs/Documents";
import EventLog from "./tabs/EventLog";
import IncidentTracking from "./tabs/IncidentTracking";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AssetInfo = () => {
  const { id } = useParams();
  const [asset, setAsset] = useState(null);
  const [activeTab, setActiveTab] = useState("basic");

  useEffect(() => {
    fetchAssetInfo();
  }, []);

  const fetchAssetInfo = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/asset/${id}`);
      setAsset(res.data);
    } catch (err) {
      console.error("Error loading asset:", err);
    }
  };

  // ----------------------------------------------------
  // UPDATE BASIC INFO (passed to BasicInfo component)
  // ----------------------------------------------------
const updateAssetField = async (payload) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/asset/basic-info/${payload.assets_id}`,
      payload
    );

    console.log("Update Response:", res.data);

    toast.success("Basic information updated successfully!", {
      position: "bottom-right",
      autoClose: 3000,
    });

    fetchAssetInfo();
  } catch (err) {
    console.error("Update error:", err);
    toast.error("Update failed!", {
      position: "bottom-right",
    });
  }
};

const tabStyle = {
  backgroundColor: "transparent",
  border: "none",
  color: "#555",
  padding: "1px 2px"
};

const activeTabStyle = {
  ...tabStyle,
  color: "#000",
  fontWeight: "400",
  borderBottom: "1px solid #000"
};

  // -----------------------------------------
  // QR PRINT FUNCTION
  // -----------------------------------------
  const printQR = () => {
    const qrCanvas = document.querySelector("#qrPrint canvas");
    const qrImage = qrCanvas.toDataURL("image/png");

    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <head>
          <title>Print Label</title>
          <style>
            @page { size: 50mm 25mm; margin: 0; }
            body { width: 50mm; height: 25mm; margin: 0; padding: 0; font-family: Arial; }
            #wrapper { display: flex; align-items: center; padding: 2mm; }
            img { width: 20mm; height: 20mm; }
            .text { font-size: 7px; margin-left: 2mm; font-weight: bold; }
          </style>
        </head>
        <body>
          <div id="wrapper">
            <img src="${qrImage}" />
            <div class="text">
              <div>${asset.name}</div>
              <div>${asset.company_asset_code}</div>
            </div>
          </div>
          <script>
            window.onload = function() { window.print(); setTimeout(()=>window.close(),300); }
          </script>
        </body>
      </html>
    `);
    win.document.close();
  };

  if (!asset) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="card p-3">
 <ToastContainer />
      <h4>Asset Information</h4>

      {/* ---------------- HEADER AREA ---------------- */}
      <div className="row mb-4">
        
        {/* Image */}
        <div className="col-md-3">
          {asset.asset_image && (
            <img
              src={`${APP_BASE_URL}/uploads/asset_image/${asset.asset_image}`}
              alt="asset"
              className="img-fluid border rounded"
            />
          )}
        </div>

        {/* Summary Table */}
        <div className="col-md-6">
          <table className="table small">
            <tbody>
              <tr>
                <th>Asset Name</th>
                <td>{asset.name}</td>
              </tr>
              <tr>
                <th>Category</th>
                <td>{asset.category_name}</td>
              </tr>
              <tr>
                <th>Asset Code</th>
                <td>{asset.company_asset_code}</td>
              </tr>
              <tr>
                <th>Department</th>
                <td>{asset.department_name}</td>
              </tr>
              <tr>
                <th>Helpdesk</th>
                <td>{asset.helpdesk_name}</td>
              </tr>
              <tr>
                <th>Location</th>
                <td>{asset.location_name}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td>{asset.status_name}</td>
              </tr>
              <tr>
                <th>Medical?</th>
                <td>{asset.is_medical ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <th>Unit Price</th>
                <td>{asset.unit_price}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* QR Code */}
        <div className="col-md-3 text-center border rounded p-3">
          <div id="qrPrint">
            <QRCodeCanvas
              value={
                `ASSET NAME: ${asset.name}
ASSET CODE: ${asset.company_asset_code}
DEPARTMENT NAME: ${asset.department_name}
HELP DESK: ${asset.helpdesk_name}
LOCATION: ${asset.location_name}
SERIAL NUMBER: ${asset.serial_number ?? ""}
WARRANTY / AMC End date: ${asset.warranty_end_date ?? ""}`
              }
              size={128}
              includeMargin={true}
            />
          </div>
          <button className="btn btn-outline-primary btn-sm mt-2" onClick={printQR}>
            Print
          </button>
        </div>
      </div>

      {/* ---------------- TABS ---------------- */}
     <ul className="nav nav-tabs mb-3">
  {[
    ["basic", "Basic Info"],
    ["location", "Location"],
    ["supplier", "Supplier"],
    ["price", "Price"],
    ["license", "License"],
    ["status", "Other Info"],
    ["work", "Work Orders"],
    ["incident", "Incident Tracking"],
    ["document", "Documents"],
    ["event", "Event Log"]
  ].map(([key, label]) => (
    <li className="nav-item" key={key}>
      <button
        className="nav-link"
        style={activeTab === key ? activeTabStyle : tabStyle}
        onClick={() => setActiveTab(key)}
      >
        {label}
      </button>
    </li>
  ))}
</ul>


      {/* ---------------- TAB CONTENT ---------------- */}
<div className="p-3" style={{ background: "transparent" }}>

        {activeTab === "basic" && (
          <BasicInfo asset={asset} updateAssetField={updateAssetField} />
        )}
        {activeTab === "location" && <LocationInfo asset={asset} />}
        {activeTab === "supplier" && <SupplierInfo asset={asset} />}
        {activeTab === "price" && <PriceInfo asset={asset} />}
        {activeTab === "license" && <LicenseInfo asset={asset} />}
        {activeTab === "status" && <StatusInfo asset={asset} />}
{activeTab === "work" && (
  <WorkOrders assetId={parseInt(asset.assets_id)} isWorkable={asset.is_workable} />
)}

        {/* {activeTab === "work" && <WorkOrders assetId={asset.assets_id} />} */}
{activeTab === "incident" && (
  <IncidentTracking
    assetId={parseInt(asset.assets_id)}
    isWorkable={parseInt(asset.is_workable)}
  />
)}
{activeTab === "document" && <Documents assetId={asset.assets_id} />}
        {activeTab === "event" && <EventLog assetId={asset.assets_id} />}
      </div>

    </div>
  );
};

export default AssetInfo;
